import React, { Component } from 'react'
import './style.css'
import Banner from '../../assets/image/banner-hompage1.jpg'
import Banner2 from '../../assets/image/banner-homepage2.jpg'
import {Button} from '@material-ui/core'
// import Slider from 'infinite-react-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {
    ButtonBack, ButtonFirst, ButtonLast, ButtonNext,
    CarouselProvider, DotGroup, ImageWithZoom, Slide, Slider,
  } from 'pure-react-carousel'
export default class tribe_banner extends Component {
    render() {
        const {image}=this.props
        return (
            <div>
                <section className='landing-tribe2 hide-mobile'>
                    <div className='banner-tribe'>
                        <h1>{this.props.title}</h1>
                        <br/>
                        <p>{this.props.subtitle}</p>
                        <br/>
                        {/* <Button variant="contained" style={{textTransform:'none',fontWeight:'bold',border:5}} color="primary" onClick={()=>window.location.assign('/schedule')}>Schedule a meeting</Button> */}
                    </div>
                    <div className='banner-img' style={{textAlign:'center'}}>
                    <div className="dot"></div>
                    <div className="image2">
                        <img src={image[0].image} className='banner-slider2'/>
                    </div>
                    <div className='sadow'></div>
                    {/* <Carousel showArrows={false} autoPlay infiniteLoop={true} showIndicators={false} showThumbs={false} showStatus={false} >
                        {image.map((data,i)=>(
                            <div >
                                <div className="image">
                                    <img src={data.image} className='banner-slider'/>
                                </div>
                                <div className='sadow'></div>
                            </div>
                        ))} 
                    </Carousel> */}
                    {/* <CarouselProvider
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        totalSlides={image.length}
                        isPlaying={true}
                        interval={5000}
                        playDirection='forward'
                    >

                        <Slider>
                           
                           {image.map((data,i)=>(
                                <Slide index={i} key={i}>
                                    <div className="image">
                                        <img src={data.image} className='banner-slider'/>
                                    </div>
                                    <div className='sadow'></div>
                                    <DotGroup className='dot-slider'/>
    
                                </Slide>
                            ))}
                        

                        </Slider>
                    </CarouselProvider> */}
                    </div>
                </section>
                <div className='image-mobile show-mobile'>
                    <div className='image-banner-mobile2'>
                        <div  className='image-banner-mobile2'>
                            <img src={Banner} />
                        </div>
                        <div className='image-caption-mobile2'>
                            <h1>{this.props.title}</h1>
                            <br/>
                            <p>{this.props.subtitle}</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}
